import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { PrintingPatternRepositoryBase } from '@skylab-shared/business';
export { PrintingPatternRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(PrintingPatternRepositoryBase)
export class PrintingPatternRepository {
    public constructor(
        private readonly weaver: Weaver,
        $http: Http
    ) { }
}
